// extracted by mini-css-extract-plugin
export default {"row":"PlatformListPage_row__vnxTh","platform_card":"PlatformListPage_platform_card__hTFvp"};